import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Select, { components } from 'react-select';
import SelectArrowImg from '../image/SelectArrowImg';
import { Log } from '../../../lib/util/CustomUtil';
import {isMobileOnly} from 'react-device-detect'
import { findIndex } from 'lodash';

/**
 * DrowDown Select Button
 */
const ProdDetailOptSelectBlock = styled.div`
    position: relative;
    display: ${props => props.display || 'block'};
    height: ${props => props.height || '40px'};
    margin-top: ${props => props.marginTop || '0px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-left: ${props => props.marginLeft || '0px'};
    margin-right: ${props => props.marginRight || '0px'};
`;



const BtnMobileSelect = styled.select`
    //width: ${props => props.width || 'fit-content'};
    width: 100%;
    font-size: 14px;
    padding: 10px;
    padding-right: 28px;
    background-color: #ffffff;
    height: 100%;
    border: 1px solid #c1c1c1;
    border-radius: 4px;
    color: ${props => props.color || '#333333'};

    appearance:none; /* 기본 스타일 없애기 */
    -webkit-appearance:none;
    -moz-appearance:none;
    -o-appearance:none;

    .select::-ms-expand {display:none;}

    &:focus {
        outline: 0;
        border: 1px solid #ffc742;
        border-radius: 4px;
    }

    &:active {
        outline: 0;
        border: 1px solid #ffc742;
        border-radius: 4px;
    }
`;

const SelectArrowImgBtn = styled.div`
    position: absolute;
    right: 4px;
    top: 12px;
`;

const BtnMobileOption = styled.option`

`;


const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            {!isMobileOnly&&<SelectArrowImg />}
        </components.DropdownIndicator>
    );
};

const customStyles = {
    option: (provided, state) => {
         //Log("option provied : " + JSON.stringify(provided));
        return {
            ...provided,
            padding: 10,
            fontSize: 14,
            color: state.isDisabled ? '#bbbbbb' : state.isSelected ? '#ffffff' : '#333333',
            backgroundColor: state.isSelected ? '#ffc742' : '#ffffff',
            cursor: state.isDisabled ? 'auto' : 'pointer'
        }
    },
    control: (provided, state) => {
        // console.log("provied : " + JSON.stringify(provided));
        const border = state.isFocused ? '1px solid #ffc742' : '1px solid #c1c1c1';
        return {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            fontSize: 14,
            border: border,
            borderRadius: 4,
            height: '40px',
            backgroundColor: '#fff',
            cursor: 'pointer',
        };
    },
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return {
            ...provided, opacity, transition,
            cursor: 'pointer'
        };
    },
    indicatorSeparator: (provided, state) => {
        // console.log("provied : " + JSON.stringify(provied));
        return {
            ...provided,
            width: 0
        };
    },
    menuList: (provided, state) => {
        // Log("provied : " + JSON.stringify(provided));
        return {
            ...provided,
            maxHeight: 165,
            paddingTop: 10,
            paddingBottom: 10,
            cursor: 'pointer'
        };
    },
    valueContainer: (provided, state) => ({
        ...provided,
        padding: 0,
        paddingLeft: "15px",
        cursor: 'pointer',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        //borderBottom: '1px dotted pink',
        paddingRight: "1px",
    }),
    menu: (provided, state) => ({
        ...provided,
        paddingLeft: 5,
        paddingRight: 5,
    }),
}


const ProdDetailOptSelect = ({ options, placeholder,
    marginTop, marginBottom, marginLeft, marginRight,
    height, onChange, isDisabled = false, reset = false, reffer }) => {

    // console.log("reset : " + reset + " options : " + JSON.stringify(options))
    const [options2, setOptoins2] = useState([]);
    const [gray, setGray] = useState(true);
    const [width, setWidth] = useState('33px');

    useEffect(() => {
        setOptoins2(options);

        if(options2 && options2.length>0){
            let length = options2[0].label.length;
            let width = (length*11) + 'px';
            setWidth(width);
        }

    }, [options]);

    const getOptionLabel = (option) => {
        if (option.disabled) {
            return (option.label + " (품절)");
        } else {
            if (option.price > 0) {
                let price = Number(option.price.toFixed(1)).toLocaleString();
                return (option.label + " ( +" + price + " )");
            }
        }

        return option.label;
    }

    const onChanegValue = (e) => {
        if(e.target.value*1 === -1) {
            let param = {value: -1};
            onChange(param);
            setGray(true);
        } else {
            let idx = findIndex(options2, (curitem) => {
                return (curitem.value*1 === e.target.value*1);
            })

            if(idx >= 0) {
                onChange(options2[idx]);
                setGray(false);
            }
        }

    }
    return (isMobileOnly?
        <ProdDetailOptSelectBlock
          height={height}
          marginTop={marginTop}
          marginBottom={marginBottom}
          marginLeft={marginLeft}
          marginRight={marginRight}>
            <BtnMobileSelect placeholder={placeholder} name="select" ref={reffer} id="select" color={gray? '#333333':'#333333'} width={width} onChange={onChanegValue} value={!!reset?"-1":null}>
                <option value="-1">{placeholder}</option>
                {
                    options.map((option, index) => {
                        return (
                          <BtnMobileOption key={option.value} value={option.value} disabled={option.disabled === 'yes'}>
                              {/*{option.label}*/}
                              {getOptionLabel(option)}
                          </BtnMobileOption>
                        );
                    })
                }
            </BtnMobileSelect>
             <SelectArrowImgBtn><SelectArrowImg /></SelectArrowImgBtn>
        </ProdDetailOptSelectBlock>
        :
        <ProdDetailOptSelectBlock
            display={options === null || options.length === 0 ? 'none' : 'block'}
            height={height}
            marginTop={marginTop}
            marginBottom={marginBottom}
            marginLeft={marginLeft}
            marginRight={marginRight}
        >

            {
                reset ? <Select
                    value={null}
                    ref={reffer}
                    isDisabled={isDisabled}
                    options={options}
                    placeholder={placeholder}
                    styles={customStyles}
                    isSearchable={false}
                    //menuIsOpen={true}
                    formatOptionLabel={getOptionLabel}
                    isOptionDisabled={(option) => option.disabled}
                    components={{ DropdownIndicator }}
                    onChange={onChange} /> :
                    <Select
                        ref={reffer}
                        isDisabled={isDisabled}
                        options={options}
                        placeholder={placeholder}
                        styles={customStyles}
                        isSearchable={false}
                        formatOptionLabel={getOptionLabel}
                        isOptionDisabled={(option) => option.disabled}
                        components={{ DropdownIndicator }}
                        // menuIsOpen={true}
                        onChange={onChange} />
            }
        </ProdDetailOptSelectBlock>
    );
};

export default ProdDetailOptSelect;
